<template>
	<div  class="scrollable only-y" v-loading.fullscreen.lock="fullScreenLoading">
    <div class="customer-top-nav no-print">
			<span class="title" >{{$t('inventorySettings.title')}}</span>
			<div class="controls">
				<el-button @click="close();">{{$t('buttons.close')}}</el-button>
        <el-button type="primary" :disabled="true" @click="createInventory">Créer un nouvel inventaire</el-button>
			</div>
		</div>
    <noInventoryCallToAction v-if="inventories.length==0 && fullScreenLoading!=true" @createNewInventory="createInventory"/>


    <div v-if="inventories.length>0" class="table-box  scrollable only-y">
		  <el-card v-for="(inv, index) in inventories" :key="inv.id" class="flex item" style="margin:20px;display:table;width:96%;padding-right:50px;border:1px #000;" :class="{ strip : index %2==0 }">
				<el-row>
					<div style="float:right;">
					<!-- <el-tooltip class="item" effect="dark" content="Permet de gérer l'inventaire" placement="top">
						<el-button
							size="mini"
							@click="handleManage(index, inv)"><i class="mdi mdi-settings" style="font-size:15px;"></i></el-button>
					</el-tooltip> -->
	
					<el-button
						size="mini"
						@click="handleEdit(index, inv)"><i class="mdi mdi-cog" style="font-size:15px;"></i></el-button>

				</div>
				<span>{{inv.name}}</span><span v-if="inv.description"> | {{inv.description}}</span>
			</el-row>
			<el-row :gutter="20">
				<!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
					<InfoStatsCard v-bind:text="'Valeur total'" v-bind:total="$n(inv.total_value,'currency')" v-bind:sign="''" v-bind:icon="'mdi-square-inc-cash'"  v-bind:status="'success'"></InfoStatsCard>
				</el-col>
				<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
					<InfoStatsCard v-bind:text="'Nb produit UVC'" v-bind:total="inv.total_uvc_quantity" v-bind:icon="'mdi-unity'"  v-bind:status="'success'" ></InfoStatsCard>
				</el-col>
				<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
					<InfoStatsCard  v-bind:text="'Nb produit unitaire'" v-bind:total="inv.total_quantity"  v-bind:icon="'mdi-numeric'"  v-bind:status="'success'" ></InfoStatsCard>
				</el-col> -->
			</el-row>	
			
			<div v-if="inv.code === 'IP'">
				<el-divider/>
				<h4>{{$t('inventorySettings.Administration')}}</h4>
				<el-row >

					<div class="feature-tile m-10" >
						<img src="@/assets/images/conciliation-inventaire-2-petit.jpeg" alt="Icône fonctionnalité" class="tile-image" />
						<div class="tile-description">
							<el-link @click="openInventoryConciliation(inv.id)">
								<h3>{{ $t('inventorySettings.reconcileInventoryTitle') }}</h3>
							</el-link>
							<p>{{ $t('inventorySettings.reconcileInventoryTitleInstruction') }}</p>
						</div>
					</div>
					<div class="feature-tile m-10">
						<img src="@/assets/images/conciliation-prix-2-petit.jpeg" alt="Icône fonctionnalité" class="tile-image" />
						<div class="tile-description">
							<el-link @click="openPriceConciliation(inv.id)">
								<h3>{{ $t('inventorySettings.reconcileInventoryPriceTitle') }}</h3>
							</el-link>
							<p>{{ $t('inventorySettings.reconcileInventoryPriceTitleInstruction') }}</p>
						</div>
					</div>
					

				</el-row>
			</div>
			</el-card>
    </div>

    <inventoryDialog :inventoryDialogVisible.sync="inventoryDialogVisible" @inventoryCreated="inventoryCreated" @inventoryUpdated="inventoryUpdated" :inventoryToEdit="inventoryToEdit" @close="closeInventoryDialog"></inventoryDialog>
		<InventoryConciliation :inventory_id="inventoryIdToReconcile" :visible="inventoryConciliationVisible" @close="closeInventoryConciliation"></InventoryConciliation>
		<PriceConciliation :inventory_id="inventoryIdToReconcile" :visible="priceConciliationVisible" @close="closePriceConciliation"></PriceConciliation>
	</div>
</template>

<script>
import axios from "axios"
import InventoryAPI from '@/services/API/inventory'

import noInventoryCallToAction from './components/no-inventory-call-to-action.vue'
import inventoryDialog from './components/inventory-dialog.vue'
import InfoStatsCard from '@/components/Info-stat-card'
import InventoryConciliation from './components/inventory-conciliation'
import PriceConciliation from './components/price-conciliation'

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      	fullScreenLoading : true,
      	// inventories : [],
      	inventoryDialogVisible : false,
      	search : '',
      	inventoryToEdit : null,
		inventoryConciliationVisible : false,
		priceConciliationVisible : false,
		inventoryIdToReconcile : null,
    };
  },components: {
    	noInventoryCallToAction,
    	inventoryDialog,
		InfoStatsCard,
		InventoryConciliation,
		PriceConciliation,
  },
  watch : {

  },
	methods: {
		openInventoryConciliation(inventoryId){
			this.inventoryIdToReconcile = inventoryId;
			this.inventoryConciliationVisible = true;
		},
		openPriceConciliation(inventoryId){
			this.inventoryIdToReconcile = inventoryId;
			this.priceConciliationVisible = true;
		},
		closeInventoryConciliation(){
			this.inventoryConciliationVisible = false;
			this.inventoryIdToReconcile = null;
		},
		closePriceConciliation(){
			this.priceConciliationVisible = false;
			this.inventoryIdToReconcile = null;
		},
    	canDelete(inventory){
	  	if (inventory.code === 'SAQ' || inventory.code === 'IP') return false;
      	if(inventory.batches==null || inventory.batches.length==0){
        	return true;
      	}
      	return false;
    },
    close(){
			this.$router.go(-1);
		},
    handleEdit(index, inventory){
      this.inventoryToEdit=inventory;
      this.openInventoryDialog();
    },
    handleManage(index, inventory){
      var index='/settings/inventories/'+inventory.id;
			this.$router.push(index);
    },
    handleDelete(index,inventory){
      this.fullScreenLoading=true;
      InventoryAPI.deleteInventory(inventory.id)
        .then(()=>{
					this.$notify({
						title: "Suppresion de l'inventaire",
						message: "L'inventaire a été supprimé avec succès",
						type: 'success'
					});
					this.invalidateInventories();
					this.fetchInventories();
       }).then(()=>{
         this.fullScreenLoading=false;
       }).catch(err=>{
				 this.$notify({
					 title: "Suppresion de l'inventaire",
					 message: "Oups... une erreur s'est produit lors de la suppression de l'inventaire. Veuillez réessayer plus tard.",
					 type: 'error'
				 });
			 })
    },
    createInventory(){
      this.inventoryToEdit=null;
      this.openInventoryDialog();
    },
    inventoryCreated(inventory){
      this.closeInventoryDialog();
			this.invalidateInventories();
			this.fetchInventories();
    },
    inventoryUpdated(){
      this.closeInventoryDialog();
			this.invalidateInventories();
			this.fetchInventories();
    },
    closeInventoryDialog(){
      this.inventoryDialogVisible = false;
    },
    openInventoryDialog(){
      this.inventoryDialogVisible = true;
    },
		...mapActions('inventory',['fetchInventories','invalidateInventories'])
	},
	computed: {
		...mapState('inventory',['inventories'])
	},
	conciliationInventaireIconeURL(){

	},
	conciliationPrixIconeURL(){
		
	},
	created(){
		this.fetchInventories()
      .then(()=>{
				this.fullScreenLoading=false;
      })
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';



.feature-tile {
	display: flex;
	align-items: center;
	// background-color: #f1f0ee;
	border-radius: 8px;
	padding: 16px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	max-width: 600px;
}

.tile-image {
	width: 80px;
	height: 80px;
	object-fit: contain;
	margin-right: 20px;
}

.tile-description h3 {
	margin: 0;
	font-size: 1.2em;
	color: #2c3e50;
}

.tile-description p {
	margin: 4px 0 0;
	color: #555;
}

.title {
	font-size : 1.8em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
